import { render } from "./RejectedApproval.vue?vue&type=template&id=784429ac&scoped=true"
import script from "./RejectedApproval.vue?vue&type=script&lang=js"
export * from "./RejectedApproval.vue?vue&type=script&lang=js"

import "./RejectedApproval.vue?vue&type=style&index=0&id=784429ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784429ac"]])

export default __exports__